import * as Yup from "yup";

export const NATIONALITY = {
  DOMESTIC: "D",
  FOREIGNER: "F",
};

export const initialValues = {
  employeeNationality: NATIONALITY.DOMESTIC,
  taxId: null,
  employeeTypeId: null,
  titleId: null,
  nameEn: null,
  name: null,
  surName: null,
  surNameEn: null,
  departmentId: null,
  positionId: null,
  email: null,
  passportNo: null,
  passportIssueCountryId: null,
  passportIssueDate: null,
  passportExpireDate: null,
  // * Visa
  visaTypeId: null,
  visaNo: null,
  visaIssueCountryId: null,
  visaIssueDate: null,
  visaExpireDate: null,
  // * Work Permit
  workPermitNo: null,
  workPermitExpireDate: null,
  workPermitIssueDate: null,
  listDepartmentId: null,
};

const EmployeeCreateSchema = Yup.object().shape({
  employeeNationality: Yup.string(),
  taxId: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.DOMESTIC,
    then: () =>
      Yup.string().required(
        "Please enter your employee identification no. / tax id."
      ),
    otherwise: () => Yup.string().notRequired(),
  }),
  employeeTypeId: Yup.string().required("Please select your employee type."),
  titleId: Yup.string().required("Please select your employee title."),
  nameEn: Yup.string().required("Please enter your employee name."),
  name: Yup.string().required("Please enter your employee name."),
  surName: Yup.string().required("Please enter your employee surname."),
  surNameEn: Yup.string().required("Please enter your employee surname."),
  departmentId: Yup.string().required(
    "Please select your employee department."
  ),
  positionId: Yup.string().required("Please select your employee position."),
  taxId: Yup.string().required("Please enter your taxID."),
  email: Yup.string()
    .email("Invalid email")
    .required("Please enter your email"),
  passportNo: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please enter passport No."),
    otherwise: () => Yup.string().notRequired(),
  }),
  passportIssueCountryId: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () =>
      Yup.string().required("Please select passport issuing country."),
    otherwise: () => Yup.string().notRequired(),
  }),
  passportExpireDate: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please select passport expire date."),
    otherwise: () => Yup.string().notRequired(),
  }),

  visaTypeId: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please select visa type."),
    otherwise: () => Yup.string().notRequired(),
  }),
  visaNo: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please enter visa No."),
    otherwise: () => Yup.string().notRequired(),
  }),
  visaIssueCountryId: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please select visa issuing country."),
    otherwise: () => Yup.string().notRequired(),
  }),
  visaExpireDate: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please select visa expire date."),
    otherwise: () => Yup.string().notRequired(),
  }),

  workPermitNo: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () => Yup.string().required("Please enter work permit No."),
    otherwise: () => Yup.string().notRequired(),
  }),
  workPermitExpireDate: Yup.string().when("employeeNationality", {
    is: (val) => val === NATIONALITY.FOREIGNER,
    then: () =>
      Yup.string().required("Please select work permit expire date."),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default EmployeeCreateSchema;
